<template>
  <AppModalEdit
    v-model="isActive"
    :show-exec-button="false"
    :confirm-on-click-cancel="false"
    cancel-button-text="閉じる"
    title="代理店マージン詳細"
  >
    <v-container v-if="isActive" grid-list-md>
      <v-layout>
        <v-flex xs1>
          <h4>名称</h4>
        </v-flex>
        <v-flex xs1>
          <template v-if="!isNoteEditMode && item.isRequestPassed">
            <v-btn
              v-if="isNameEditMode"
              class="inline-save-button"
              small
              color="primary"
              @click="saveNewName"
              >保存する</v-btn
            >
            <v-icon
              v-else
              class="inline-edit-button"
              @click="changeNameEditMode"
            >
              edit
            </v-icon>
          </template>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs10 offset-xs2>
          <TextFieldInline
            v-show="isNameEditMode"
            ref="editNameArea"
            v-model="newName"
          />
          <span
            v-show="!isNameEditMode"
            :class="{ 'not-passed-record': !item.isRequestPassed }"
          >
            {{ item.displayData.name }}
          </span>
        </v-flex>
      </v-layout>
      <h4>マージン率</h4>
      <v-layout>
        <v-flex xs10 offset-xs2>
          <span :class="{ 'not-passed-record': !item.isRequestPassed }">
            {{ item.displayData.marginPercent }}
          </span>
        </v-flex>
      </v-layout>
      <h4>使用可能期間</h4>
      <v-layout>
        <v-flex xs10 offset-xs2>
          <span :class="{ 'not-passed-record': !item.isRequestPassed }">
            {{ item.displayData.dateRange }}
          </span>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs1>
          <h4>メモ</h4>
        </v-flex>
        <v-flex xs1>
          <template v-if="!isNameEditMode && item.isRequestPassed">
            <v-btn
              v-if="isNoteEditMode"
              class="inline-save-button"
              small
              color="primary"
              @click="saveNewNote"
              >保存する</v-btn
            >
            <v-icon
              v-else
              class="inline-edit-button"
              @click="changeNoteEditMode"
            >
              edit
            </v-icon>
          </template>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs10 offset-xs2>
          <v-textarea
            v-show="isNoteEditMode"
            ref="editNoteArea"
            v-model="newNote"
            :rows="3"
          />
          <span
            v-show="!isNoteEditMode"
            :class="{ 'not-passed-record': !item.isRequestPassed }"
            style="white-space: pre-wrap"
            >{{ item.displayData.note }}</span
          >
        </v-flex>
      </v-layout>
      <RequestsTable :records="item.requests" @cancelRequest="cancelRequest" />
    </v-container>
  </AppModalEdit>
</template>

<script>
import RequestsTable from './EditAgencyMarginDetailModalRequests'
import TextFieldInline from '@/components/Shared/CrudUI/TextFieldInline'

export default {
  components: { RequestsTable, TextFieldInline },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      newNote: '',
      newName: '',
      isNoteEditMode: false,
      isNameEditMode: false,
    }
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    changeDateRange(obj) {
      this.useDateRange = obj.useDateRange
      this.startDate = obj.startDate
      this.endDate = obj.endDate
    },
    changeNoteEditMode() {
      this.newNote = this.item.note
      this.isNoteEditMode = true
      this.$nextTick(() => this.$refs.editNoteArea.focus())
    },
    saveNewNote() {
      this.isNoteEditMode = false
      console.log('saveNewNote')
      console.log(this.newNote)
    },
    changeNameEditMode() {
      this.newName = this.item.name
      this.isNameEditMode = true
      this.$nextTick(() => this.$refs.editNameArea.focus())
    },
    saveNewName() {
      this.isNameEditMode = false
      console.log('saveNewName')
      console.log(this.newName)
    },
    async cancelRequest(target) {
      const result = await this.$confirm(undefined, {
        body: 'この申請を取り消しますがよろしいですか？',
      })
      if (result) {
        this.$emit('cancelRequest', target.id)
      }
    },
  },
}
</script>

<style scoped>
.v-textarea {
  padding: 0;
}
.v-textarea >>> textarea {
  font-weight: 500;
  font-size: 14px;
}
.inline-edit-button {
  font-size: 18px;
  padding-left: 32px;
}
.inline-save-button {
  height: 18px;
  padding: 0;
  margin: 0 0 0 16px;
}
.not-passed-record {
  opacity: 0.25;
}
</style>
